import { Field } from '@stories/Elements/Forms/Fields/Form.styles';
import React, { FunctionComponent } from 'react';
import { CheckboxInput, CheckboxLabel } from './Checkbox.styles';

export enum CheckboxTheme {
  White = 0,
  Black = 1,
}

interface CheckboxProps {
  theme?: CheckboxTheme;
}

const Checkbox: FunctionComponent<CheckboxProps> = ({ theme }) => {
  return (
    <Field>
      <CheckboxInput id="chkMarketing" theme={theme} />
      <CheckboxLabel htmlFor="chkMarketing" theme={theme}>
        *I acknowledge I have read and understood the Milwaukee Privacy Policy and I consent to the processing of my
        personal data for marketing and profiling purposes.
      </CheckboxLabel>
    </Field>
  );
};

export default Checkbox;
